import { OptionRendererProps } from '@src/components/combobox/Combobox';
import { CheckCircledIcon, Cross1Icon } from '@radix-ui/react-icons';
import { CustomTooltip } from '@src/components/tooltip/Tooltip';
import { cn } from '@/lib/utils';

export const IdsOptionRenderer = ({ isValueSelected, option }: OptionRendererProps) => {
  return (
    <div className="flex items-center relative w-full">
      <div className="w-6 min-w-6">
        {isValueSelected && <CheckCircledIcon/>}
      </div>
      <div className="max-w-full line-clamp-2">
        {option.label}
      </div>
      {isValueSelected && (
        <CustomTooltip content="Remove option">
          <Cross1Icon
            className={cn(
              "ml-auto z-10 r-0 cursor-pointer max-w-3 min-w-3",
            )}
          />
        </CustomTooltip>
      )}
    </div>
  )
};

